module.exports = __webpack_public_path__ + "b28bceef73feaa395de22af7b96367e8.png";